import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { map } from 'rxjs/operators';
import { INotification } from 'src/app/common/model/notification.model';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';

import { environment } from 'src/environments/environment';
import { IPagination } from '../../model/util.model';
import { SIBASI_SYSTEM_APP_MODULES } from '../../model/sibasi-system.model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  unreadNotificationCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private notificationsCountSubject = new BehaviorSubject<number>(0);
  notificationsCount$ = this.notificationsCountSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    private router: Router
  ) {}
  updateNotificationsCount(count: number): void {
    this.notificationsCountSubject.next(count);
  }
  getAllNotifications(): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotification[]>>(
      `${environment.api_url}notification/user/all`
    );
  }
  getUnreadNotifications(): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient
      .get<
        ISibasiHTTPResponse<INotification[]>
      >(`${environment.api_url}notification/user/unread`)
      .pipe(
        map((res) => {
          this.unreadNotificationCount.next(res.result.length);

          return res;
        })
      );
  }
  getNotificationsCount(): Observable<ISibasiHTTPResponse<number>> {
    return this.httpClient
      .get<
        ISibasiHTTPResponse<number>
      >(`${environment.api_url}notification/user/unread/count`)
      .pipe(
        map((res) => {
          this.unreadNotificationCount.next(res.result);
          return res;
        })
      );
  }

  adminGetAllNotifications(): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotification[]>>(
      `${environment.api_url}notification/admin/all`
    );
  }
  adminGetUnreadNotifications(): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotification[]>>(
      `${environment.api_url}notification/admin/unread`
    );
  }
  readNotification(
    notificationId: string
  ): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotification[]>>(
      `${environment.api_url}notification/read/${notificationId}`
    );
  }
  markAllRead(): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotification[]>>(
      `${environment.api_url}notification/markRead/all`
    );
  }
  deleteNotification(
    notificationId: string
  ): Observable<ISibasiHTTPResponse<INotification>> {
    return this.httpClient.delete<ISibasiHTTPResponse<INotification>>(
      `${environment.api_url}notification/delete/${notificationId}`
    );
  }

  getRecentActivities(): Observable<any> {
    return this.httpClient.get(`${environment.api_url}activities`);
  }

  getLatestNotifications(): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INotification[]>>(
      `${environment.api_url}notification/user/latest`
    );
  }

  markNotificationAsRead(
    notificationId: string
  ): Observable<ISibasiHTTPResponse<INotification>> {
    return this.httpClient.post<ISibasiHTTPResponse<INotification>>(
      `${environment.api_url}notification/read/${notificationId}`,
      {}
    );
  }

  getUnreadNotificationCount() {
    this.httpClient.get(`${environment.api_url}notification/user/unread/count`);
  }

  markAllNotificationAsRead(): Observable<ISibasiHTTPResponse<INotification[]>> {
    return this.httpClient
      .post<
        ISibasiHTTPResponse<INotification[]>
      >(`${environment.api_url}notification/markRead/all`, {})
      .pipe(
        map((res) => {
          this.unreadNotificationCount.next(0);
          return res;
        })
      );
  }

  getNotificationsPaginated(
    body: IPagination<INotification[]>
  ): Observable<ISibasiHTTPResponse<IPagination<INotification[]>>> {
    return this.httpClient
      .post<
        ISibasiHTTPResponse<IPagination<INotification[]>>
      >(`${environment.api_url}notification/paginated`, body)
      .pipe(
        map((res) => {
          if (body['isUnread']) {
            this.unreadNotificationCount.next(res.result.totalCount);
          }
          return res;
        })
      );
  }

  navigateToNotification(notification: INotification): void {
    if (!notification.isRead) {
      this.markNotificationAsRead(notification._id!).subscribe();
    }
    let navigationURL = '';
    const notificationModuleItemId = notification.moduleItemId?._id;
    switch (notification.moduleType) {
      case SIBASI_SYSTEM_APP_MODULES.MEETING:
        navigationURL = `/meetings/${notificationModuleItemId}/1`;
        break;
      case SIBASI_SYSTEM_APP_MODULES.TASK:
        navigationURL = `/tasks/taskView/${notificationModuleItemId}/`;
        break;
      case SIBASI_SYSTEM_APP_MODULES.SIBASIFILE:
        navigationURL = `/documents`;
        break;

      default:
        break;
    }

    if (notificationModuleItemId && navigationURL) {
      this.router.navigate([navigationURL]);
    }
  }

  activateEmailNotificationsForOrgAdmin(): Observable<
    ISibasiHTTPResponse<INotification>
  > {
    return this.httpClient.get<ISibasiHTTPResponse<INotification>>(
      `${environment.api_url}user/set/email`
    );
  }
}
